import { render } from "./view_workflow_clients.html?vue&type=template&id=cec94d4e&scoped=true&external"
import script from "./view_workflow_clients.js?vue&type=script&lang=js&external"
export * from "./view_workflow_clients.js?vue&type=script&lang=js&external"

import "./ViewWorkflowClients.vue?vue&type=style&index=0&id=cec94d4e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cec94d4e"]])

export default __exports__